import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { Flex, Text, UnstyledButton } from '@mantine/core';

interface Props {
	label: string;
	iconVariant: 'checkmark' | 'close-v3';
	color: string;
	backgroundColor: string;
	borderColor: string;
	disabled: boolean;
	dataTestId: TEST_ELEMENT_IDS;
	onClick: () => void;
}

export const DecisionButton = ({
	label,
	iconVariant,
	color,
	backgroundColor,
	borderColor,
	disabled,
	dataTestId,
	onClick,
}: Props) => (
	<UnstyledButton
		onClick={onClick}
		disabled={disabled}
		data-testid={dataTestId}
		style={{
			flex: 1,
			padding: '3rem 1rem',
			borderRadius: '0.25rem',
			border: `1px solid ${borderColor}`,
			backgroundColor,
			opacity: disabled ? 0.6 : 1,
			cursor: disabled ? 'not-allowed' : 'pointer',
		}}
	>
		<Flex direction="column" align="center" gap="0.5rem">
			<Icon variant={iconVariant} size="vlg" color={color} />
			<Text size="md" fw={600} c={color}>
				{label}
			</Text>
		</Flex>
	</UnstyledButton>
);
